import { createApp } from 'vue';
import App from './App';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import { setupRouter } from '@/router';
import { setupStore } from '@/store';
import '@/styles/index.less'; //公共样式文件
import '@/styles/theme.less'; //公共样式文件

if (process.env.VUE_APP_USE_MOCK === 'true') {
  import('@/mock/index');
}

//导入组件库
import * as antIcon from '@ant-design/icons-vue';
let IconData = antIcon;

import isAuthDirective from '@/utils/buttonPower';

import { setupCustomComponents } from '@/utils/plugins';

const app = createApp(App);

function setupPlugins() {
  // 注册全局常用的ant-design-vue组件
  // setupAntd(app);
  // 注册全局自定义组件,如：<svg-icon />
  setupCustomComponents(app);
}

async function setupApp() {
  //挂载vueX（pinia）
  setupStore(app);
  // 挂载路由
  await setupRouter(app);
  // 添加到全局
  // 注册组件
  Object.keys(IconData).forEach(key => {
    app.component(key, IconData[key]);
  });

  app.config.globalProperties.$antIcons = IconData;
}
setupPlugins();
setupApp();

app.use(Antd).use(isAuthDirective).mount('#app');
